import { version } from "react";

const defaultFont = { size: 14, style: 'normal', family: 'Helvetica Neue' }

const plugin = (chart, font = {}) => {
    const ctx = chart.ctx
    const chartArea = chart.chartArea;
    const selectedFont = { ...defaultFont, ...font }

    chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i)
        var maxWidth = -1;
        // find max width text
        meta.data.forEach((element, index) => {
            var horizontal = true
            var aliasOrName = (dataset.data[index].metadata || {})["aliasOrNameHorizontal"]

            if (!aliasOrName) {
                aliasOrName = (dataset.data[index].metadata || {})["aliasOrNameVertical"]
                horizontal = false
            }

            if (!!aliasOrName) {
                const width = ctx.measureText(aliasOrName).width;

                if (width > maxWidth)
                    maxWidth = width;
            }
        })

        const hidden = (meta.hidden === null) ? chart.data.datasets[i].hidden : meta.hidden;
        if (!hidden) { 
            meta.data.forEach((element, index) => {
                ctx.fillStyle = dataset.borderColor
                ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                var horizontal = true
                var aliasOrName = (dataset.data[index].metadata || {})["aliasOrNameHorizontal"]

                if (!aliasOrName) {
                    aliasOrName = (dataset.data[index].metadata || {})["aliasOrNameVertical"]
                    horizontal = false
                }

                if (!!aliasOrName) {
                    const padding = 4
                    const offset = 2
                    const height = selectedFont.size + padding + offset
                    const width = horizontal ? ctx.measureText(aliasOrName).width : maxWidth
                    const widthP = width + offset + padding

                    if (horizontal) {
                        const x = (meta.data[index]._model.x)
                        const y = (meta.data[index]._model.y - height)

                        if (chartArea.top < y + height + padding && chartArea.bottom >= y + height && chartArea.left < x + padding && chartArea.right > x - 2 * padding) {
                            var offsetY = 0;

                            if (chartArea.top > y - selectedFont.size + padding)
                                offsetY = height * 2;

                            ctx.fillRect(x - width / 2 - padding, y - selectedFont.size / 2 - padding + offsetY, width + 2 * padding, selectedFont.size + 2 * padding);
                            ctx.fillStyle = '#ffffff';
                            ctx.fillText(aliasOrName, x, y + offsetY);
                        }
                    }
                    else {
                        const x = (meta.data[index]._model.x - widthP)
                        const y = (meta.data[index]._model.y)

                        if (chartArea.top < y + selectedFont.size && chartArea.bottom > y - selectedFont.size && chartArea.left <= x + widthP && chartArea.right > x) {
                            var offsetX = 0;

                            if (chartArea.left >= x - width + padding)
                                offsetX = widthP * 2;

                            ctx.fillRect(x - width / 2 - padding + offsetX, y - selectedFont.size / 2 - padding, width + 2 * padding, selectedFont.size + 2 * padding);
                            ctx.fillStyle = '#ffffff';
                            ctx.fillText(aliasOrName, x + offsetX, y);
                        }
                    }
                }
            })
        }
    })
}

export default plugin



// WEBPACK FOOTER //
// ./App/components/modules/chart-plugins/drawAliasOrNameLabel.js